export default __webpack_public_path__ + "static/media/image05.6f910b46.webp";